import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=99757db8&scoped=true&"
import script from "./page4.vue?vue&type=script&lang=js&"
export * from "./page4.vue?vue&type=script&lang=js&"
import style0 from "./page4.vue?vue&type=style&index=0&id=99757db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99757db8",
  null
  
)

export default component.exports